export const getTranslation = (businessData, type) => {
  const translations = businessData?.[0]?.Translations;

  if (!Array.isArray(translations) || !type) {
    return null;
  }

  const translation = translations.find(
    (item) => item?.Type === type && item?.Translation,
  );

  if (!translation) {
    return null;
  }

  return <h2>{translation.Translation}</h2>;
};
